import { atomWithStorage } from 'jotai/utils';
import { ALL_FILTER, type SessionGrouping, type SessionListSort, type SessionListStatusFilter } from '@localagent/sdk';
import { configureAtomDevtools } from '../utils/tracking';
import { createPersistedStorage } from '../utils/persistence';

/**
 * Session-list chrome preferences. Deliberately NOT URL state: the sidebar is
 * global chrome on every route, so a query param would pollute every unrelated
 * page (app-shell ADR-012; app-shell ADR-006 governs page state).
 */
const SESSION_GROUPING_STORAGE_KEY = 'localagent-session-grouping';
const SESSION_ROLE_FILTER_STORAGE_KEY = 'localagent-session-filter-role';
const SESSION_GOAL_FILTER_STORAGE_KEY = 'localagent-session-filter-goal';
const SESSION_STATUS_FILTER_STORAGE_KEY = 'localagent-session-filter-status';
const SESSION_WORKSPACE_FILTER_STORAGE_KEY = 'localagent-session-filter-workspace';
const SESSION_SORT_STORAGE_KEY = 'localagent-session-sort';
const SESSION_EMPTY_GROUPS_STORAGE_KEY = 'localagent-session-empty-groups';
const SESSION_COLLAPSED_STORAGE_KEY = 'localagent-session-collapsed-groups';
const SESSION_SIDEBAR_STORAGE_VERSION = 2;

export const sessionGroupingAtom = configureAtomDevtools(
  atomWithStorage<SessionGrouping>(
    SESSION_GROUPING_STORAGE_KEY,
    'goal',
    createPersistedStorage<SessionGrouping>({ version: SESSION_SIDEBAR_STORAGE_VERSION }),
    { getOnInit: true },
  ),
  'chat/sessionGrouping',
);

export const sessionRoleFilterAtom = configureAtomDevtools(
  atomWithStorage<string>(
    SESSION_ROLE_FILTER_STORAGE_KEY,
    ALL_FILTER,
    createPersistedStorage<string>({ version: SESSION_SIDEBAR_STORAGE_VERSION }),
    { getOnInit: true },
  ),
  'chat/sessionRoleFilter',
);

export const sessionGoalFilterAtom = configureAtomDevtools(
  atomWithStorage<string>(
    SESSION_GOAL_FILTER_STORAGE_KEY,
    ALL_FILTER,
    createPersistedStorage<string>({ version: SESSION_SIDEBAR_STORAGE_VERSION }),
    { getOnInit: true },
  ),
  'chat/sessionGoalFilter',
);

export const sessionStatusFilterAtom = configureAtomDevtools(
  atomWithStorage<SessionListStatusFilter>(
    SESSION_STATUS_FILTER_STORAGE_KEY,
    'all',
    createPersistedStorage<SessionListStatusFilter>({ version: SESSION_SIDEBAR_STORAGE_VERSION }),
    { getOnInit: true },
  ),
  'chat/sessionStatusFilter',
);

export const sessionWorkspaceFilterAtom = configureAtomDevtools(
  atomWithStorage<string>(
    SESSION_WORKSPACE_FILTER_STORAGE_KEY,
    ALL_FILTER,
    createPersistedStorage<string>({ version: SESSION_SIDEBAR_STORAGE_VERSION }),
    { getOnInit: true },
  ),
  'chat/sessionWorkspaceFilter',
);

export const sessionSortAtom = configureAtomDevtools(
  atomWithStorage<SessionListSort>(
    SESSION_SORT_STORAGE_KEY,
    'last_activity',
    createPersistedStorage<SessionListSort>({ version: SESSION_SIDEBAR_STORAGE_VERSION }),
    { getOnInit: true },
  ),
  'chat/sessionSort',
);

export const sessionShowEmptyGroupsAtom = configureAtomDevtools(
  atomWithStorage<boolean>(
    SESSION_EMPTY_GROUPS_STORAGE_KEY,
    false,
    createPersistedStorage<boolean>({ version: SESSION_SIDEBAR_STORAGE_VERSION }),
    { getOnInit: true },
  ),
  'chat/sessionShowEmptyGroups',
);

export const sessionCollapsedGroupsAtom = configureAtomDevtools(
  atomWithStorage<string[]>(
    SESSION_COLLAPSED_STORAGE_KEY,
    [],
    createPersistedStorage<string[]>({ version: SESSION_SIDEBAR_STORAGE_VERSION }),
    { getOnInit: true },
  ),
  'chat/sessionCollapsedGroups',
);
